import React, { useEffect, useRef } from 'react';
import { useScreenDetail, remCss } from 'src/helpers';

export const FlexFitWidth = ({ children, itemWidth, gap = 10, padding }) => {
  const [colAmount, setColAmount] = React.useState(8);
  const containerRef = useRef(null);
  const screen = useScreenDetail();

  useEffect(() => {
    if (containerRef.current) {
      const dis = itemWidth;
      let col = Math.ceil((containerRef.current.clientWidth - padding * 2) / remCss(dis));
      col =
        col * dis + gap * (col - 1) > containerRef.current.clientWidth - padding * 2
          ? col - 1
          : col;

      if (col !== colAmount) {
        setColAmount(col);
      }
    }
  }, [colAmount, gap, itemWidth, padding, screen]);

  return (
    <div
      style={{
        gap: remCss(gap),
        paddingLeft: remCss(padding),
        paddingRight: remCss(padding),
        display: 'grid',
        overflow: 'auto',
        minWidth: 0,
        gridTemplateColumns: `repeat(${colAmount}, minmax(${itemWidth}px, 1fr))`
      }}
      ref={containerRef}
    >
      {children}
    </div>
  );
};
